export default __webpack_public_path__ + "static/media/Jen Looper.bc9dcde4.jpg";